var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollContainer",staticClass:"scroll-container",on:{"wheel":function($event){$event.preventDefault();return _vm.handleScroll.apply(null, arguments)}}},[_c('div',{ref:"scrollWrapper",staticClass:"scroll-wrapper",style:({top: _vm.top + 'px'})},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac61d394","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScrollBar/index.vue
// module id = null
// module chunks = 